<template>
    <div id="app">
        <div class="content">
            <router-view :key="$route.fullPath"/>
            <notifications group="errors" type="error" classes="notification-error" position="bottom left"/>
            <notifications group="warn" type="warn" classes="notification-warn" position="bottom left"/>
            <notifications group="success" type="success" classes="notification-success" position="bottom left"/>
        </div>
        <div v-if="!$route.meta.hideFooter" class="footer">
            <Footer/>
        </div>
    </div>
</template>

<script>
    import Footer from '@/component/user/Footer'

    export default {
        name: 'App',
        components: {
            Footer
        },
    }
</script>

<style>
    @import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');

    html, body {
        height: 100%;
    }

    #app {
        display: flex;
        flex-direction: column;
        height: 100%;
        background-color: #F0EAD6;
    }

    .content {
        flex: 1 0 auto;
        background-color: #F0EAD6;
    }

    .footer {
        flex-shrink: 0;
    }

    * {
        //padding: 0;
        margin: 0;
        font-family: Poppins, serif;
    }

    h1 {
        font-size: calc((32 / 15) * 1em);
    }

    p {
        font-size: 15px;
    }

    input {
        border-color: #967bb6;
    }

    .notification-warn {
        padding: 10px;
        margin: 0 5px 5px;
        font-size: 12px;
        color: #ffffff;
        background: #ffb648 !important;
        border-left-color: #f48a06 !important;
    }

    .notification-error {
        padding: 10px;
        margin: 0 5px 5px;
        font-size: 12px;
        color: #ffffff;
        background: #E54D42 !important;
        border-left-color: #B82E24 !important;
    }

    .notification-success {
        padding: 10px;
        margin: 0 5px 5px;
        font-size: 12px;
        color: #ffffff;
        background: #68CD86 !important;
        border-left-color: #42A85F !important;
    }

    .message-wrapper {
        display: flex;
        background-color: #FF7F7F;
        color: #FFF;
    }
</style>
